<template>
    <div>
        <b-card v-if="isLoaded">
            <div style="margin-bottom:10px">
                <b-row align-h="end">
                    <year-select style="margin-right: 20px" @onchange="onYearChange"/>
                    <region-multi-select
                        style="margin-right: 10px"
                        :selectedRegionId="selectedSiteGroupId"
                        :regions="siteGroups"
                        @oninput="selectSiteGroupId"/>
                    <site-multi-select
                        :selectedSiteId="selectedSiteId"
                        :givenSites="filteredSites"
                        @oninput="selectSiteId"
                    />
                </b-row>
            </div>
            <div class="scroll-content">
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.distributions, consumptions: initialEmissions.consumption, isSummary: true}"
                        :title="''"
                        :group-type="'scopeGroup'"
                    />
                </div>
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.compounds?initialEmissions.compounds.filter(emission => emission.source === 'businessTravel') : null, consumptions: initialEmissions.consumption, isSummary: false}"
                        :data-types="initialEmissions.emissionTypes"
                        :title="$t('businessTravel')"
                    />
                </div>
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.compounds?initialEmissions.compounds.filter(emission => emission.source === 'employeeCommuting') : null, consumptions: initialEmissions.consumption, isSummary: false}"
                        :data-types="initialEmissions.emissionTypes"
                        :title="$t('employeeCommuting')"
                    />
                </div>
                <!--
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.compounds?initialEmissions.compounds.filter(emission => emission.source === 'accomodation') : null, consumptions: initialEmissions.consumption, isSummary: false}"
                        :title="$t('accomodation')"
                    />
                </div>
                -->
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.compounds?initialEmissions.compounds.filter(emission => emission.source === 'purchasedGoodsAndServices') : null, consumptions: initialEmissions.consumption, isSummary: false}"
                        :data-types="initialEmissions.emissionTypes"
                        :title="$t('purchasedGoodsAndServices')"
                    />
                </div>
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <table-and-chart
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :initial-emissions="{data: initialEmissions.compounds.filter(emission => emission.source === 'wasteGeneratedInOperations'), consumptions: initialEmissions.consumption, isSummary: false}"
                        :data-types="initialEmissions.emissionTypes"
                        :title="$t('wasteGeneratedInOperations')"
                    />
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import qs from 'qs';

import Multiselect from 'vue-multiselect';
import YearSelect from '../../../components/YearSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';
import SiteMultiSelect from '../../../components/SiteMultiSelect';

import TableAndChart from './components/TableAndChart';

export default {
    components: {
        TableAndChart,
        SiteMultiSelect,
        RegionMultiSelect,
        YearSelect,
        Multiselect
    },
    name: 'ScopeThree',
    data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            initialEmissions: {
                current: []
            },
            currentTypes: ['flights', 'paper', 'personel-cars']//, 'accomodation'
        };
    },

    methods: {
        retrieveEmissions() {
            this.$Progress.start();
            return this.axios
                .get(
                    `/report/emission?${qs.stringify({
                        startDate: this.createUTCDate(this.year, 0, 1),
                        endDate: this.createUTCDate(this.year + 1, 0, 1),
                        emissionId: 1,
                        siteId: this.selectedSiteId,
                        groupId: this.selectedSiteGroupId,
                        scope: 'Scope-3'
                    })}`
                )
                .then(({data}) => {
                    this.initialEmissions = data;
                    this.isLoaded = true;
                    this.$Progress.finish();
                    return data;
                });
        },
        selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.retrieveEmissions();
        },
        selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(site => {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.retrieveEmissions();
        },
        onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({name: 'scope-3', query: {year: this.year}});
            this.retrieveEmissions();
        }
    },

    created() {
        this.selectedSiteId = this.route.params.site_id
            ? Number(this.route.params.site_id)
            : this.selectedSiteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        this.retrieveEmissions();
    }
};
</script>

<style lang="scss" scoped>
.borderless {
    th {
        border-top: none;
        font-size: 1.2em;
    }
}

.card-nav {
    cursor: pointer;
    &:hover {
        color: #1c7430;
    }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "domestic-waste": "Atık"
        },
        "en": {
            "domestic-waste": "Waste"
        }
    }
</i18n>




// WEBPACK FOOTER //
// src/views/Analysis/Tabs/Scope3.vue